var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"azNav"},_vm._l((_vm.artistsAz),function(alpha){return _c('div',{key:alpha,staticClass:"letter cursor-pointer",on:{"click":function($event){return _vm.azSelected(alpha)}}},[_vm._v(" "+_vm._s(alpha)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }